// extracted by mini-css-extract-plugin
export default {"container":"BottomBanner_container__zfhyz"};